import queryString, { type ParseOptions, type StringifyOptions } from 'query-string';
import { useLocation } from 'react-router-dom';

const parseOptions: ParseOptions = { arrayFormat: 'comma' };
const stringifyOptions: StringifyOptions = { arrayFormat: 'comma', skipNull: true, skipEmptyString: true };

const useQueryParams = () => {
  const { search } = useLocation();
  const params = queryString.parse(search, parseOptions);

  const setParam = (key: string, value: string) => {
    const newParams = { ...params, [key]: value };
    const newSearch = queryString.stringify(newParams, stringifyOptions);
    window.history.replaceState({}, '', `${window.location.pathname}?${newSearch}`);
    return newParams;
  };

  const setParams = (paramsUpdates: Record<string, string>) => {
    const newParams = { ...params, ...paramsUpdates };
    const newSearch = queryString.stringify(newParams, stringifyOptions);
    window.history.replaceState({}, '', `${window.location.pathname}?${newSearch}`);
    return newParams;
  };

  return { params, setParam, setParams };
};

export default useQueryParams;
